import React from 'react';
import { CTAButton } from './CTAButton';
export function CloseSection() {
  return <section className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#0f172a',
    borderColor: '#334155'
  }} data-id="element-2">
      <div className="max-w-3xl mx-auto" data-id="element-3">
        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-10 text-center" style={{
        color: '#f1f5f9'
      }} data-id="element-4">
          Solo Hay Dos Caminos
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-5">
          {/* Path 1 */}
          <div className="rounded-md p-6 border" style={{
          backgroundColor: '#1e293b',
          borderColor: '#334155'
        }} data-id="element-6">
            <p className="text-2xl mb-4" data-id="element-7">😔</p>
            <h3 className="text-lg font-bold mb-4" style={{
            color: '#64748b'
          }} data-id="element-8">
              Camino 1:
            </h3>
            <div className="space-y-3 text-base" style={{
            color: '#94a3b8'
          }} data-id="element-9">
              <p data-id="element-10">Cierras esta página.</p>
              <p data-id="element-11">Piensas "tal vez después".</p>
              <p data-id="element-12">En 6 meses estás exactamente igual.</p>
              <p data-id="element-13">
                Mismos ingresos. Mismo techo. La misma frustración silenciosa.
              </p>
            </div>
          </div>

          {/* Path 2 */}
          <div className="rounded-md p-6 border-2" style={{
          backgroundColor: '#1e293b',
          borderColor: '#f59e0b'
        }} data-id="element-14">
            <p className="text-2xl mb-4" data-id="element-15">😊</p>
            <h3 className="text-lg font-bold mb-4" style={{
            color: '#f59e0b'
          }} data-id="element-16">
              Camino 2:
            </h3>
            <div className="space-y-3 text-base" style={{
            color: '#f1f5f9'
          }} data-id="element-17">
              <p data-id="element-18">
                Descargas la Guía PDF por{' '}
                <strong style={{
                color: '#f59e0b'
              }} data-id="element-19">
                  $49.999
                </strong>{' '}
                hoy.
              </p>
              <p data-id="element-20">
                Este fin de semana construyes tu primera página en menos de 1
                hora.
              </p>
              <p data-id="element-21">En 30 días cobras tu primer pago desde casa.</p>
              <p data-id="element-22">
                En 6 meses vas en camino a los{' '}
                <strong style={{
                color: '#f59e0b'
              }} data-id="element-23">
                  6 millones al mes
                </strong>
                .
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-12 space-y-3" data-id="element-24">
          <p className="text-lg" style={{
          color: '#94a3b8'
        }} data-id="element-25">
            La guía existe. Las herramientas funcionan. Los clientes están
            pagando.
          </p>
          <p className="text-xl font-bold" style={{
          color: '#f1f5f9'
        }} data-id="element-26">
            La única pieza que falta eres tú.
          </p>
        </div>

        <CTAButton text="SÍ — DE CERO A 6 MILLONES AL MES EMPIEZA HOY" subtitle="Guía PDF · Descarga Inmediata · $49.999 · Garantía de 30 Días" scrollTo="ebook-main" data-id="element-27" />

        <p className="text-sm text-center mt-6" style={{
        color: '#dc2626'
      }} data-id="element-28">
          ⚠️ Solo 300 personas a precio de lanzamiento. Luego $99.
        </p>
      </div>
    </section>;
}